import { render } from "./SajuGuideComponent.vue?vue&type=template&id=1eb32dfc&scoped=true"
import script from "./SajuGuideComponent.vue?vue&type=script&lang=js"
export * from "./SajuGuideComponent.vue?vue&type=script&lang=js"

import "./SajuGuideComponent.vue?vue&type=style&index=0&id=1eb32dfc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb32dfc"]])

export default __exports__